<div
  class="container"
  [ngClass]="{ bigPadding: bigPadding, smallPadding: !bigPadding }"
>
  <div [ngClass]="{ 'white-shadow-bg': whiteShadowBG }">
    <img src="/assets/ic_empty.png" class="dark-icon icon" alt="Empty" />
    <p>{{ text }}</p>
  </div>
</div>
